import axios from "axios";
import { useForm } from "react-hook-form";
import React, { useEffect, useState } from "react";
import { TOKEN } from "../graphql/client";

export const SetProject = () => {
	const [project, setProject] = useState("non-existing");
	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
	} = useForm();

	useEffect(() => {
		checkProject();
	}, []);

	const validateProject = async (project_id: number): Promise<boolean> => {
		// eslint-disable-next-line max-len
		return await axios.get(`https://api.acceptance.foleon.cloud/v2/magazine/title/${project_id}`, {
			headers: {
				Authorization: `Bearer ${TOKEN}`,
			},
		});
	};

	const checkProject = () => {
		const projectId = Number(localStorage.getItem("project_id"));
		validateProject(projectId)
			.then(() => {
				setProject("existing");
			})
			.catch(() => {
				setProject("non-existing");
			});
	};

	const onSubmit = () => {
		const code = watch("exampleRequired");
		localStorage.setItem("project_id", code);
		window.location.reload();
	};

	return (
		<div>
            Project ID is: {project}
			{/* include validation with required or other standard HTML validation rules */}
			<input {...register("exampleRequired", { required: true })} />
			{/* errors will return when field validation fails  */}
			{errors.exampleRequired && <span>This field is required</span>}
			<button onClick={handleSubmit(onSubmit)}>send</button>
		</div>
	);
};

export default SetProject;
